import * as React from "react";
import { forwardRef } from "react";
const SvgWaitingForData = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	height: "1em",
	viewBox: "0 0 20 20",
	width: "1em",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("g", {
	fill: "none",
	fillRule: "evenodd",
	stroke: "none",
	strokeWidth: 1
}, /* @__PURE__ */ React.createElement("path", {
	d: "M10,0 L10,0 C15.5228475,-1.01453063e-15 20,4.4771525 20,10 L20,10 C20,15.5228475 15.5228475,20 10,20 L10,20 C4.4771525,20 6.76353751e-16,15.5228475 0,10 L0,10 C-6.76353751e-16,4.4771525 4.4771525,1.01453063e-15 10,0 Z",
	fill: "currentColor"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M9.47277778,8.5 L15.7777778,15.0475 L14.8605556,16 L4.22222222,4.9525 L5.13944444,4 L8.55555556,7.5475 L8.55555556,7.54 L9.48,8.5 L9.47277778,8.5 Z M10.2022222,13 L6.38166667,13 L6.38166667,15.25 L3.5,12.25 L6.38166667,9.25 L6.38166667,11.5 L8.75777778,11.5 L10.2022222,13 Z M11.3144444,8.5 L9.87,7 L13.6183333,7 L13.6183333,4.75 L16.5,7.75 L13.6183333,10.75 L13.6183333,8.5 L11.3144444,8.5 Z",
	fill: "#FFFFFF"
})));
const ForwardRef = forwardRef(SvgWaitingForData);
export default ForwardRef;
